import Vue from 'vue'
import VueRouter from 'vue-router'
import CourseList from '../views/CourseList.vue'
import CourseDetail from '../views/CourseDetail.vue'
import AgentCourses from '../views/AgentCourses.vue'
import Playground from '../views/Playground.vue'
import NotFound from '../views/NotFound.vue'
import NetworkIssue from '../views/NetworkIssue.vue'
import store from '@/store/index'
import NProgress from 'nprogress'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/courses',
    meta: {
      breadcrumb: ''
    }
  },
  // {
  //   path: '/login',
  //   name: 'login-user',
  //   component: LoginUser
  // },
  {
    path: '/courses',
    name: 'course-list',
    component: CourseList,
    props: true,
    meta: {
      breadcrumb: 'Summary',
      requiresAuth: true
    }
  },
  {
    path: '/courses/:courseid',
    name: 'course-detail',
    component: CourseDetail,
    props: true,
    meta: {
      breadcrumb: routeParameters => {
        return `${routeParameters.course.name}`
      },
      requiresAuth: true
    },
    beforeEnter(routeTo, routeFrom, next) {
      store
        .dispatch('course/serverFetchCourse', routeTo.params.courseid)
        .then(course => {
          routeTo.params.course = course
          next()
        })
        .catch(error => {
          if (error.response && error.response.status == 404) {
            next({ name: '404', params: { resource: 'course' } })
          } else {
            next({ name: 'network-issue' })
          }
        })
    }
  },
  {
    path: '/agent/:agentId',
    name: 'agent-courses',
    component: AgentCourses,
    props: true,
    meta: {
      breadcrumb: routeParameters => `${routeParameters.params.agentId}`,
      requiresAuth: true
    },
    beforeEnter(routeTo, routeFrom, next) {
      routeTo.params.agent = store.getters['course/getAgentById'](
        routeTo.params.agentId
      )
      if (routeTo.params.agent == null) {
        store
          .dispatch('course/fetchAgentCourse', {
            id: routeTo.params.agentId,
            name: ''
          })
          .then(courses => {
            routeTo.params.agent = routeTo.params.agent = store.getters[
              'course/getAgentById'
            ](routeTo.params.agentId)
            next()
          })
          .catch(error => {
            if (error.response && error.response.status == 404) {
              next({ name: '404', params: { resource: 'course' } })
            } else {
              next({ name: 'network-issue' })
            }
          })
      } else {
        next()
      }
    }
  },
  {
    path: '/playground',
    name: 'playground',
    component: Playground,
    props: true,
    meta: {
      breadcrumb: ''
    }
  },
  {
    path: '/404',
    name: '404',
    component: NotFound,
    props: true,
    meta: {
      breadcrumb: ''
    }
  },
  {
    path: '/network-issue',
    name: 'network-issue',
    component: NetworkIssue,
    meta: {
      breadcrumb: ''
    }
  },
  {
    path: '*',
    redirect: {
      name: '404',
      params: { resource: 'page' },
      meta: { breadcrumb: '' }
    }
  },
  // otherwise redirect to home
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  //mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((routeTo, routeFrom, next) => {
  NProgress.configure({ showSpinner: false })
  // redirect to login page if not logged in and trying to access a restricted page
  NProgress.start()
  const publicPages = ['/', '/network-issue']
  const authRequired = !publicPages.includes(routeTo.path)

  if (routeTo.query && routeTo.query.token) {
    const token = routeTo.query.token
    store.commit('user/SET_TOKEN', token)
  }

  const loggedIn = localStorage.getItem('user')

  if (authRequired && !loggedIn) {
    return next('/network-issue')
  }
  next()
})

router.afterEach(() => {
  NProgress.done()
})
export default router
